import { render, staticRenderFns } from "./MBFDialog.vue?vue&type=template&id=a98ead16&scoped=true"
import script from "./MBFDialog.vue?vue&type=script&lang=js"
export * from "./MBFDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98ead16",
  null
  
)

export default component.exports